import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from "@angular/router";
import { CookieService } from "ngx-cookie-service";
import { AuthenticationService } from "../services/authentication.service";
import { Beneficiario } from "../types/Beneficiario";

@Injectable({
  providedIn: "root",
})
export class AuthGuard implements CanActivate {
  private sessionCookie: string;
  private tokenPayload?: {
    nameid: string;
    UserApelido: string;
    UserHandle: string;
    given_name: string;
    UserRole: string;
    exp: number;
    iat: number;
    nbf: number;
    role: string;
    unique_name: string;
  };

  beneficiario?: Beneficiario;

  constructor(
    private authService: AuthenticationService,
    private router: Router,
    private cookieService: CookieService
  ) {
    this.sessionCookie = this.cookieService.get("access_token");
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    const currentUser = this.authService.currentUserValue;

    if (!currentUser) {
      this.redirectToLogin();
      return false;
    }

    if (!this.decodeToken(currentUser.token)) {
      this.logout();
      return false;
    }

    const routeRoles = route.data?.roles;
    const userRoleId = currentUser.tipoUsuarioId;
    const existeTermo = currentUser.existeTermo;


    if (!existeTermo && state.url !== "/aceite" && userRoleId === 1) {
      this.router.navigate(["/aceite"]);
      return false;
    }



    if (routeRoles && !routeRoles.includes(userRoleId)) {
      return this.handleUnauthorizedAccess(currentUser);
    }

    return true;
  }

  /**
   * Decodifica o token JWT e armazena o payload
   */
  private decodeToken(token: string): boolean {
    try {
      const payload = token.split(".")[1];
      this.tokenPayload = JSON.parse(atob(payload));
      return true;
    } catch {
      console.error("Erro ao decodificar o token JWT");
      return false;
    }
  }

  /**
   * Lógica de tratamento quando o usuário não tem permissão
   */
  private handleUnauthorizedAccess(user: any): boolean {
    const { tipoUsuarioId, alterarSenha } = user;

    if (tipoUsuarioId === 1) {
      if (alterarSenha && this.router.url !== "/trocar-senha") {
        this.router.navigate(["/trocar-senha"]);
        return false;
      }

      this.router.navigate(["/detalhes"]);
      return true;
    }

    this.router.navigate(["/detalhes"]);
    return false;
  }

  private logout(): void {
    this.authService.logout().subscribe(() => this.router.navigate(["/login"]));
  }

  private redirectToLogin(): void {
    this.authService.logout().subscribe(() => this.router.navigate(["/login"]));
  }
}
